import { z } from 'zod';

import { colorFromValueAndPreset, responsiveColorValueSchema } from '../../../mixins';
import type { TabDefaultV0 } from './v0';
import { tabDefaultDataSchema as tabDefaultV0DataSchema, tabDefaultSchema as tabDefaultV0BaseSchema } from './v0';

/** v1 stores every colour as one string — a theme preset name or a literal. */
export const tabDefaultDataSchema = tabDefaultV0DataSchema.extend({
    header: tabDefaultV0DataSchema.shape.header.extend({
        backgroundColor: responsiveColorValueSchema,
        activeBackgroundColor: responsiveColorValueSchema,
        textColor: responsiveColorValueSchema,
        activeTextColor: responsiveColorValueSchema,
        activeContourColor: responsiveColorValueSchema,
        separatorColor: responsiveColorValueSchema,
    }),
    body: tabDefaultV0DataSchema.shape.body.extend({
        backgroundColor: responsiveColorValueSchema,
    }),
});

export const tabDefaultV1Schema = tabDefaultV0BaseSchema.extend({
    props: tabDefaultDataSchema,
    version: z.literal(1),
});

export type TabDefaultV1 = z.output<typeof tabDefaultV1Schema>;

type ColorPair = { value?: string | null; presetName?: string | null };
type ResponsivePair = { desktop: ColorPair; tablet?: ColorPair; mobile?: ColorPair };

const toString = (responsive: ResponsivePair) => ({
    desktop: colorFromValueAndPreset(responsive.desktop),
    ...(responsive.tablet ? { tablet: colorFromValueAndPreset(responsive.tablet) } : {}),
    ...(responsive.mobile ? { mobile: colorFromValueAndPreset(responsive.mobile) } : {}),
});

/** The `{ value, presetName }` pair becomes the one string, the preset winning. */
export const migrateTabV0ToV1 = (tab: TabDefaultV0): z.input<typeof tabDefaultV1Schema> => {
    const { header, body } = tab.props;

    return {
        ...tab,
        version: 1,
        props: {
            ...tab.props,
            header: {
                ...header,
                backgroundColor: toString(header.backgroundColor),
                activeBackgroundColor: toString(header.activeBackgroundColor),
                textColor: toString(header.textColor),
                activeTextColor: toString(header.activeTextColor),
                activeContourColor: toString(header.activeContourColor),
                separatorColor: toString(header.separatorColor),
            },
            body: { ...body, backgroundColor: toString(body.backgroundColor) },
        },
    };
};
